import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {distinctUntilChanged, map, merge, tap} from 'rxjs';

import {EVENT_BUS} from '@shared/domain/tokens/event-bus.token';
import {AccountModeChangedEvent} from '@shared/application/events/account/account-mode-changed.event';
import {ACCOUNT_MODE} from '@core/entities/account/account-modes/enum/account-mode.enum';
import {AccountResetRequestedEvent} from '@shared/application/events/account/account-reset-requested.event';
import {WalletStatusChangedEvent} from '@platform/event-bus/domain/events/wallet/wallet-status-changed.event';

@Injectable({providedIn: 'root'})
export class PlatformOnAccountResetSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    merge(
      this.eventBus.ofType(AccountResetRequestedEvent).pipe(map(() => false)),
      this.eventBus.ofType(AccountModeChangedEvent).pipe(map(event => event.modeType === ACCOUNT_MODE.wallet)),
    )
      .pipe(
        distinctUntilChanged(),
        tap(isActive => this.eventBus.publish(new WalletStatusChangedEvent({isActive}))),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
